<a href="javascript:;" (click)="downloadFile()">{{
  'Dashboard::ClickHereToDownloadTopIntents' | abpLocalization
}}</a>
